<template>
  <div class="panelContent" :style="{ backgroundColor: overrideBackgroundColour }">
    <div class="row center-xs">
      <div v-if="panel.title && panel.title.text" class="col-xs-12 mar-b20">
        <div :style="{'width': '100%', 'font-size': panel.autofit ? (panel.width * 0.5) + 'vw' : panel.title.size + 'px', color: panel.title.colour}">{{panel.title.text}}</div>
      </div>
      <div class="col-xs-12">
        <div v-if="data || data === 0" :style="{ width: '100%', 'font-size': panel.autofit ? (1.5 * panel.width) + 'vw' : panel.content.size + 'px', color: overrideColour || panel.content.colour}">{{data.prefix || ''}}{{format(data)}}{{data.suffix || ''}}</div>
        <div v-else :style="{'font-size': '28px', color: panel.content.colour}">Loading</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import alarmChecker from "../../../utils/alarms";
export default {
  props: ["panel", "data", "definition"],
  data() {
    return {
      overrideBackgroundColour: "",
      overrideColour: "",
      pulseTimer: undefined
    };
  },
  destroyed() {
    if (this.pulseTimer) clearInterval(this.pulseTimer);
  },
  methods: {
    format(value) {
      let val = value;
      if (this.definition.formattingOptions) {
        switch (this.definition.formattingOptions.type) {
          case "duration":
            if (this.definition.formattingOptions.format) {
              val = moment.utc(val * 1000).format(this.definition.formattingOptions.format);
            } else {
              val = moment.duration(val).humanize();
            }
            break;
          case "epoch":
            val = moment(val * 1000).format(this.definition.formattingOptions.format || "HH:mm:ss");
            break;
        }
      }
      return val;
    },
    checkAlarms() {
      let triggered;
      if (this.panel.alarms && this.panel.alarms.length) {
        console.log(JSON.stringify(this.panel.alarms))
        let definition = this.definition
        let data = this.data
        this.panel.alarms.forEach(alarm => {
          if (triggered) return;
          if (alarmChecker.check(alarm, definition, data)) triggered = JSON.parse(JSON.stringify(alarm));
        });
      }
      if (triggered) {
        this.overrideBackgroundColour = triggered.backgroundColour;
        this.overrideColour = triggered.colour;
        if (triggered.pulse && !this.pulseTimer) {
          let loop = false;
          this.pulseTimer = setInterval(() => {
            if (loop) {
              this.overrideBackgroundColour = triggered.backgroundColour;
              this.overrideColour = triggered.colour;
            } else {
              this.overrideBackgroundColour = "";
              this.overrideColour = "";
            }
            loop = !loop;
          }, 1000);
        }
      } else {
        clearInterval(this.pulseTimer);
        this.pulseTimer = undefined;
        this.overrideBackgroundColour = "";
        this.overrideColour = "";
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler(val, oldVal) {
        this.checkAlarms()
      }
    },
    panel: {
      deep: true,
      handler(val, oldVal) {
        this.checkAlarms()
      }
    }
  }
};
</script>

<style>
</style>
